export default __webpack_public_path__ + "static/media/phone_calling.a0152496.gif";